import React from 'react';
import PropTypes from 'prop-types';
import {
  FDLabelText, FDStack, FDTitleText,
} from '@facet-wealth/design';
import MuiLinearProgress from '@mui/material/LinearProgress';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { BeneficiaryAllocation } from './BeneficiaryAllocation';

const useStyles = buildUseStyles('BeneficiaryGrouping', () => ({
  progress: {
    height: '2px !important',
  },
}));

export const BeneficiaryGrouping = ({
  resources, totalAllocation, resourceIndexMap, emptyTitle, title, onChange,
}) => {
  let color = 'info';
  if (totalAllocation > 100) {
    color = 'error';
  } else if (totalAllocation === 100) {
    color = 'success';
  }
  const classes = useStyles();
  return (
    <FDStack direction={'column'} spacing={2}>
      <FDStack direction={'column'}>
        <FDTitleText value={title} />
        <MuiLinearProgress
          variant={'determinate'}
          value={Math.min(totalAllocation, 100)}
          color={color}
          className={classes.progress}
        />
      </FDStack>
      <FDStack wrap spacing={2}>
        {resources.map((resource) => {
          const remaining = resources.filter(v => v.id() !== resource.id()).reduce((acc, curr) => {
            return acc - +curr.attr('sharePercentage');
          }, 100);
          return (
            <BeneficiaryAllocation
              resource={resource}
              onChange={onChange}
              resourceIdx={resourceIndexMap[resource.id()]}
              key={resource.id()}
              remaining={remaining}
            />
          );
        })}
        {resources.length === 0 ? (
          <FDLabelText value={emptyTitle} size={'lg'} />
        ) : null}
      </FDStack>
    </FDStack>
  );
};

BeneficiaryGrouping.propTypes = {
  title: PropTypes.string.isRequired,
  totalAllocation: PropTypes.number.isRequired,
  emptyTitle: PropTypes.string.isRequired,
  resources: PropTypes.array.isRequired,
  resourceIndexMap: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
